import React from "react";
import {
  useCurrentUser,
  useCurrentUserId,
} from "../../../hooks/useCurrentUser";
import ClientExerciseHistoryPage from "../../../components/client-exercise-history/ClientExerciseHistoryPage";

const ClientExerciseHistoryRoute = () => {
  const client = useCurrentUser();
  return (
    <ClientExerciseHistoryPage
      clientId={client.id}
      clientUsername={client.username}
    />
  );
};

export default ClientExerciseHistoryRoute;
